module.exports = __webpack_public_path__ + "media/images/icon/calendar-d5641895d0da7aad9a1b2b7d78479687.svg";